import { scoreBytesToXml } from './load';
import type { ParsedScore } from './model';
import { readScore } from './read';

export * from './model';
export { ScoreParseError, type ScoreErrorCode } from './errors';
export { scoreBytesToXml, decodeXmlBytes, extractMxl } from './load';
export { readScore, clefKind } from './read';
export { unrollMeasures, type PlaybackStep, type UnrollResult } from './unroll';
export { matchVoicePart, normalizeName } from './voices';
export { assignLines, onLine, partLineCount, isOtherLine } from './lines';
export { buildTimeline, secondsAtBeat, midiToFrequency, DEFAULT_QUARTER_BPM, type TimelineOptions } from './timeline';
export { beatAtSeconds, positionAtSeconds, timelineRange, firstNoteFrom, type ScorePosition } from './position';
export { summarizeScore, assignParts, assignmentsFromSummary, SUMMARY_VERSION, type SummarizeOptions } from './summary';

/** Read an uploaded score file (.musicxml, .xml or .mxl bytes, or MusicXML text). */
export function parseScore(input: Uint8Array | string): ParsedScore {
  return readScore(typeof input === 'string' ? input : scoreBytesToXml(input));
}
